import styled from 'styled-components';
import Typography from '../../common/typography';
export const BusinessProfileList = styled.div `
  display: grid;
  grid-template-columns: repeat(
    ${({ $columnCount = 2 }) => $columnCount},
    minmax(0, 1fr)
  );
  gap: ${({ theme }) => theme.spacing.lg}px
    ${({ theme }) => theme.spacing.xl}px;
  min-width: 0;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    grid-template-columns: repeat(
      ${({ $columnCount = 2 }) => Math.min($columnCount, 2)},
      minmax(0, 1fr)
    );
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    grid-template-columns: 1fr;
  }
`;
export const BusinessProfileInfoValue = styled(Typography) `
  min-width: 0;
  padding-inline-start: ${({ $paddingInlineStart }) => $paddingInlineStart}px;
  overflow-wrap: anywhere;
  word-break: break-word;

  a {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
